
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes",
      function () {
        return require("private-next-pages/notes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notes"])
      });
    }
  